/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var DrawingIcon = createIcon("DrawingIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M.988 22.942S2.4 21.485 2.55 17.73a3.81 3.81 0 011.089-2.743 3.75 3.75 0 015.3 5.3 8.838 8.838 0 01-7.951 2.655v0Zm9.829-12.445 2.642 2.642",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2 1.729a2.772 2.772 0 00-4.067.162L7.7 14.163a3.752 3.752 0 012.087 2.118L22.039 5.8a2.772 2.772 0 00.161-4.071v0Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});